import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PageLayout, PageLayoutTabs } from '@thinknet-gmbh/platform-common-ui';
import { PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';

import { useRouteQuery } from 'src/common/helpers';
import { usePermissionCheck } from 'src/hooks/permission-check.hook';

import { getEmployeePage, getEmployeePageType, getTabPath } from './employee.helpers';
import { EmployeeList } from './sub-pages/employee-list';
import { EmployeeDetailsLimitedView } from './sub-pages/employee-details-limited-view';
import { EMPLOYEE_PAGES } from './employee.constants';
import EmployeeRouteGuard from '../../components/employee/employee-route-guard';

const Employee: React.FC = () => {
  const { t } = useTranslation('employee');
  const navigate = useNavigate();
  const query = useRouteQuery();
  const type: string = query.get('type') || '';
  const id: string = query.get('id') || '';

  const { checkIfHadPermission } = usePermissionCheck();

  return (
    <EmployeeRouteGuard>
      {checkIfHadPermission(PLATFORM_PERMISSIONS.memberManagement) ? (
        <PageLayoutTabs
          defaultTab={getEmployeePageType(type)}
          pageTitle={t('labels.employee')}
          onTabChange={tab => navigate(getTabPath(tab, id))}
          elements={getEmployeePage(type).map(({ tab, tabIndex, Page }) => ({
            tab: t(`labels.${tab}`),
            tabIndex,
            component: <Page />,
          }))}
        />
      ) : type === EMPLOYEE_PAGES.employeeLimitedView ? (
        <EmployeeDetailsLimitedView />
      ) : (
        <PageLayout pageTitle={t('labels.employee')}>
          <EmployeeList limitedView />
        </PageLayout>
      )}
    </EmployeeRouteGuard>
  );
};

export default Employee;
